import * as React from "react";
import styled from "styled-components";
const StyledSpan = styled.span(
  ({ theme }) => `
  color: ${theme.colors.gray[60]};
  font-weight: normal;
`
);
const InputOptionalInfo = () => /* @__PURE__ */ React.createElement(StyledSpan, null, "(Opt.)");
export default InputOptionalInfo;
